// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1DGcC","footer":"ModalUpdate_footer__2os0X"};